import React, { useState, useEffect } from 'react';
import { Layout, Row } from 'antd';
// import { isMobile, MobileView } from 'react-device-detect';
import { Link, withRouter } from 'react-router-dom';
// import { UserOutlined } from '@ant-design/icons';
// import { useSelector, useDispatch } from 'react-redux';
// import { flow } from 'lodash-es';
// actions
import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';
// import AppFooter from './AppFooter';
import logo_white from '../assets/img/logo_white.png';
import logo_icon from '../assets/img/logo-icon.jpeg';
const { Content, Footer, Sider } = Layout;

const AppLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    // Code inside componentDidMount can be placed here
    // if there's any equivalent functionality needed.
  }, []);

  const onCollapse = (collapsed) => {
    // console.log(collapsed);
    setCollapsed(collapsed);
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
        <Row className="logo" justify="center">
          <Link to="/">
            {collapsed ? (
              <img
                style={{ height: 30, width: 'auto' }}
                src={logo_icon}
                alt="Logo"
              />
            ) : (
              <img
                style={{ height: 40, width: 'auto' }}
                src={logo_white}
                alt="Logo"
              />
            )}
          </Link>
        </Row>
        <AppSidebar />
      </Sider>

      <Layout className="site-layout">
        {/* <Header className="site-layout-background" style={{ padding: 0 }} /> */}
        <AppHeader></AppHeader>
        <Content style={{ margin: '16px 16px', overflow: 'auto' }}>
          <div
            className="site-layout-background"
            style={{ padding: 16, minHeight: 480 }}>
            {children}
          </div>
        </Content>
        <Footer style={{ textAlign: 'center' }}>
          Yobuma ©2024 Created by Yobuma
        </Footer>
      </Layout>
    </Layout>
  );
};

export default withRouter(AppLayout);
